import { useTheme } from '../contexts/ThemeContext'
import { SunIcon, MoonIcon } from './Icons'
import '../styles/ThemeToggle.css'

function ThemeToggle({ compact = false }) {
  const { theme, toggleTheme } = useTheme()
  const isDark = theme === 'dark'

  return (
    <div className={`theme-toggle-container ${compact ? 'compact' : ''}`}>
      {!compact && (
        <span className="theme-label">
          <SunIcon size={16} />
        </span>
      )}
      <button
        className={`theme-toggle-slider ${isDark ? 'dark' : ''}`}
        onClick={toggleTheme}
        aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        role="switch"
        aria-checked={isDark}
      >
        <span className="toggle-knob">
          {isDark ? <MoonIcon size={12} /> : <SunIcon size={12} />}
        </span>
      </button>
      {!compact && (
        <span className="theme-label">
          <MoonIcon size={16} />
        </span>
      )}
    </div>
  )
}

export default ThemeToggle
